/* eslint-disable no-param-reassign */

/* @todo: this mixin is temporary. Waiting for decision about internationalization. */
import fr from '@/retail/assets/locales/fr.json'

export default {
  async install(Vue) {
    const labels = { fr }
    const locale = 'fr'

    const localLabels = labels[locale] || {}

    const getBooleanLabel = (value: boolean): string | undefined => {
      const output = localLabels[value ? 'yes' : 'no']
      return output
    }

    const getLabel = (id = ''): string | undefined => {
      const output = id.split('.').reduce((accumulator, value) => accumulator && accumulator[value], localLabels)
      return output
    }

    Vue.prototype.$staticBooleanLabel = getBooleanLabel
    Vue.prototype.$staticLabel = getLabel

    Vue.filter('staticBooleanLabel', getBooleanLabel)
    Vue.filter('staticLabel', getLabel)
  },
}
